import { useContext } from "react";
import ForwardArrow from "../../../amt/components/icons/ForwardArrow";
import { formatAmount } from "../../../app-constants";
import appStyles from "../../../App.module.css";
import { IPortuguesePurchasePathContext } from "../../config/interface";
import { PortuguesePurchasePathContext } from "../../PortuguesePurchasePath";

type MobileFooterProps = {
  title: string;
  onClickBtn?: () => void;
};
const PPMobileFooter = ({ title, onClickBtn }: MobileFooterProps) => {
  const { quoteData, quoteResult } = useContext(PortuguesePurchasePathContext) as IPortuguesePurchasePathContext;
  const getBenefitsCount = () => {
    const hasExcessFees = quoteData.excess_fee ? 1 : 0;
    const count = hasExcessFees + 1;
    return count;
  };

  return (
    <div className={appStyles.bfMobileFooter}>
      <div className={appStyles.bfMobileFooterLeft}>
        <h1 className={appStyles.colorPrimary}>
          {formatAmount(quoteResult?.quoted_price || 0, "US", quoteData.currency?.value || "EUR")}
        </h1>
        <a
          className={appStyles.bfbadge}
          href="#addedBenefits"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById("addedBenefits")?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }}
        >
          {getBenefitsCount()} benefits added
        </a>
      </div>
      <div className={appStyles.bfMobileFooterRight}>
        <button
          className={`${appStyles.bfButton} ${appStyles.bfbuttonHasIcon} ${appStyles.bfbuttonIconAfter}`}
          type={title === "checkout" ? "button" : "submit"}
          onClick={onClickBtn}
        >
          {title}
          {` ${formatAmount(quoteResult?.quoted_price || 0, "US", quoteData.currency?.value || "EUR")}`}
          <span className={`${appStyles.bfButtonIcon}`}>
            <ForwardArrow />
          </span>
        </button>
      </div>
    </div>
  );
};

export default PPMobileFooter;
